import React, { useState } from 'react';
import { useCart } from '../context/CartContext';

export default function ProductCard({ product }) {
  const { addToCart } = useCart();
  const [justAdded, setJustAdded] = useState(false);

  const handleAdd = () => {
    addToCart(product);
    setJustAdded(true);
    setTimeout(() => setJustAdded(false), 1200);
  };

  return (
    <div className="product-card hud-frame">
      <span className="unit-tag">UNIT_{String(product.id).padStart(3, '0')}</span>
      <div className="image-frame">
        <img src={product.image} alt={product.name} />
      </div>
      <h4>{product.name}</h4>
      <p>Rs{product.price}.00</p>
      <button className={`view-button ${justAdded ? 'added' : ''}`} onClick={handleAdd}>
        {justAdded ? '[ ADDED ✓ ]' : '[ ADD_TO_CART ]'}
      </button>
    </div>
  );
}